import { render, staticRenderFns } from "./notesSubjectComponent.vue?vue&type=template&id=20ac4f07&"
import script from "./notesSubjectComponent.vue?vue&type=script&lang=js&"
export * from "./notesSubjectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports